import type { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { nvLoginPath } from "@/components/navigator/nv-paths";
import { useAuth } from "@/contexts/auth-context";
import type { AccessLevel } from "@/lib/access";

interface RequireAccessProps {
  allow: AccessLevel[];
  // Where to send a signed-in user whose level is not allowed (guests always go to /login)
  fallback?: string;
  children?: ReactNode;
}

// Route guard by access level (vault "설계/권한 모델"). The API enforces the same rule;
// this only keeps users from landing on screens they cannot use.
export function RequireAccess({ allow, fallback = "/", children }: RequireAccessProps) {
  const { accessLevel, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!allow.includes(accessLevel)) {
    if (accessLevel === "guest") {
      return <Navigate to={nvLoginPath(location.pathname + location.search)} replace />;
    }
    return <Navigate to={fallback} replace />;
  }
  return children ? <>{children}</> : <Outlet />;
}
